import { Box, Heading, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import React, { forwardRef } from 'react';
import heroCardStyles from '../../../../Components/HeroCard/HeroCard.css';
import bngDomainSuggestionsStyles from './BngDomainSuggestionsSection.scss';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { BngDomainSuggestionsDataHooks } from './dataHooks';
const BngDomainSuggestionsHeading = /*#__PURE__*/forwardRef((_ref, ref) => {
  let isLoading = _ref.isLoading;
  const query = CoreDomainSearchStore.useQuery();
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const nameSuggestion = query.trim();
  if (!isLoading && !nameSuggestion) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    direction: "horizontal",
    gap: "SP2",
    verticalAlign: "top",
    marginBottom: "SP6",
    paddingBottom: "0px",
    width: "100%"
  }, isLoading ? /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: heroCardStyles.skeletonGroup
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: heroCardStyles.skeleton,
    width: "280px",
    height: "20px"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(SparklesFilledSmall, {
    color: "var(--domains-wsr-color-B40)"
  })), /*#__PURE__*/React.createElement(Heading, {
    size: "small",
    as: "h2",
    className: bngDomainSuggestionsStyles.bngDomainSuggestionsHeading,
    dataHook: BngDomainSuggestionsDataHooks.domainSuggestionsTitle
  }, t('domain_search.bng_results.domain_suggestions.title', {
    nameSuggestion
  }))));
});
export default BngDomainSuggestionsHeading;
//# sourceMappingURL=BngDomainSuggestionsHeading.js.map